const apiUrl = 'https://letzteshemdback.up.railway.app';
window.baseURL = 'https://letzteshemdback.up.railway.app';
window.startPixarTransformation = async function (imageBase64, promptText) {
  try {
    // 1️⃣ First API URL for transformation
    const transformUrl = `${apiUrl}/transformpet`;

    // Prepare the payload
    const payload = {
      image: imageBase64, // Base64 image string
      style: "pixar",
      watermark: {
        url: "https://cdn.shopify.com/s/files/1/0896/3434/1212/files/watermarklogo.png",
        width: 200,
        height: 200,
        spaceBetweenWatermarks: 100
      },
      prompt: promptText
    };

    // Show loading UI if needed
    if (typeof window.showLoadingPopup === "function") {
      window.showLoadingPopup();
    }

    // Send POST request to start the job
    const response = await fetch(transformUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (typeof window.setLoadingProgress === "function") {
      window.setLoadingProgress(10, 'Image is ready for proccessing..');
    }

    if (result.success && result.jobId) {
      console.log("Job started successfully:", result.jobId);

      // Store jobId globally
      window.currentPixarJobId = result.jobId;

      // 2️⃣ Poll job status until it's complete
      const finalResult = await pollPixarJobStatus(result.jobId);
      return finalResult;
    } else {
      console.error("Pixar transformation failed:", result);
      return null;
    }
  } catch (error) {
    console.error("Error in startPixarTransformation:", error);
    if (typeof window.hideLoadingPopup === "function") {
      window.hideLoadingPopup();
    }
    return null;
  }
};

// Helper function to poll job status
async function pollPixarJobStatus(jobId) {
  window.setLoadingProgress(20, 'Image Processing Sarted...');
  const statusUrl = `${apiUrl}/statuspet/${jobId}`;
  let attempt = 0;
  let data;
  const maxAttempts = 30; // stop after 30 tries

  while (attempt < maxAttempts) {
    attempt++;
    window.setLoadingProgress(20+attempt, "Work in progress...");
    const res = await fetch(statusUrl);
    data = await res.json();

    const status = (data.status || data.jobStatus || "");

    if (status.toLowerCase() === "completed") {
      console.log("Transformation complete:", data);
      
      window.resultImageUrl = data.resultImageUrl;
      window.processedImageUrl = data.processedImageUrl;
      window.processedPrintImageUrl = data.processedPrintImageUrl;
      window.watermarkedImageUrlToShow = data.watermarkedImageUrlToShow;
      window.watermarkedOriginalImageUrl = data.watermarkedOriginalImageUrl;

      window.setLoadingProgress(90, 'Image is ready to display..');
      return data;
    } else if (status === "failed" || status === "error") {
      console.error("Transformation failed:", data);
      return null;
    }

    await new Promise(resolve => setTimeout(resolve, 3000));
  }

  console.error(`Job did not complete after ${maxAttempts} attempts.`);
  return data;
}